import { Outlet, useLocation } from "react-router-dom";

export default function Page() {
    return (
        <div className="w-full h-full">
            <Outlet />
        </div>
    );
}